import React from 'react';
import { motion } from 'framer-motion';
import { BotanicalLeaf } from './BotanicalLeaf';
const triggers = ['Lácteos Modificados', 'Gluten Oculto', 'Azúcares Falsos', 'Aceites Inflamatorios', 'Falsos Saludables'];
export function MethodSOS() {
  return <section className="py-24 bg-forest text-cream relative overflow-hidden" data-id="element-173">
      <div className="absolute bottom-0 right-0 text-sage opacity-10 w-64 h-96 transform rotate-45 translate-y-1/4" data-id="element-174">
        <BotanicalLeaf data-id="element-175" />
      </div>
      <div className="absolute top-0 left-0 text-sage opacity-10 w-48 h-64 transform -rotate-45 -translate-y-1/4 -translate-x-1/4" data-id="element-176">
        <BotanicalLeaf data-id="element-177" />
      </div>

      <div className="container mx-auto px-6 max-w-5xl relative z-10" data-id="element-178">
        <div className="flex flex-col lg:flex-row gap-16 items-center" data-id="element-179">
          <motion.div className="flex-1" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-180">
            <h2 className="text-4xl md:text-5xl font-serif mb-6 text-cream" data-id="element-181">
              El Método SOS: <br data-id="element-182" />
              <span className="text-sage italic" data-id="element-183">Eliminar, No Sustituir</span>
            </h2>
            <p className="text-lg text-cream/80 mb-8 leading-relaxed" data-id="element-184">
              La clave no está en añadir más cosas a tu rutina, sino en quitar
              lo que te está dañando. Hemos identificado los 5 disparadores
              invisibles que hinchan tu cuerpo en cuestión de horas.
            </p>
            <p className="text-lg text-cream/80 leading-relaxed" data-id="element-185">
              Al soltar estos "venenos" cotidianos, le das a tu sistema
              digestivo el respiro que necesita para desinflamarse por sí solo.
            </p>
          </motion.div>

          <motion.div className="flex-1 w-full" initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-186">
            <div className="bg-cream/5 backdrop-blur-md rounded-3xl p-8 border border-sage/20" data-id="element-187">
              <h3 className="text-2xl font-serif mb-8 text-center text-sage" data-id="element-188">
                Los 5 Disparadores Invisibles
              </h3>
              <div className="space-y-4" data-id="element-189">
                {triggers.map((trigger, index) => <motion.div key={index} className="flex items-center gap-4 bg-white/10 p-4 rounded-xl" initial={{
                opacity: 0,
                x: 20
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.4,
                delay: 0.3 + index * 0.1
              }} data-id="element-190">
                    <div className="w-10 h-10 rounded-full bg-sage text-forest flex items-center justify-center font-serif font-bold text-lg shrink-0" data-id="element-191">
                      {index + 1}
                    </div>
                    <span className="text-lg font-medium tracking-wide" data-id="element-192">
                      {trigger}
                    </span>
                  </motion.div>)}
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}